import { connect } from 'react-redux';
import Health, {
  Props as HealthProps,
} from '@/pages/CompanyReport/components/Health';

import { getHealthSelector } from '../redux/selectors';

type ContainerProps = Partial<Pick<HealthProps, 'sectionNumber' | 'companyId'>>;
type StateProps = Omit<HealthProps, 'sectionNumber'>;

const mapStateToProps = (state, ownProps: ContainerProps): StateProps => {
  const health = getHealthSelector(state, ownProps);
  return {
    companyId: health.companyId,
    companyName: health.companyName,
    isDataMeaningless: health.isDataMeaningless,
    isBank: health.isBank,
    isFund: health.isFund,
    longTermAssets: health.longTermAssets,
    longTermAssetsFormatted0DP: health.longTermAssetsFormatted0DP,
    longTermAssetsFormatted2DP: health.longTermAssetsFormatted2DP,
    longTermLiabilities: health.longTermLiabilities,
    longTermLiabilitiesFormatted0DP: health.longTermLiabilitiesFormatted0DP,
    longTermLiabilitiesFormatted2DP: health.longTermLiabilitiesFormatted2DP,
    reportingCurrencyISO: health.reportingCurrencyISO,
    reportingUnit: health.reportingUnit,
    shortTermAssets: health.shortTermAssets,
    shortTermAssetsFormatted0DP: health.shortTermAssetsFormatted0DP,
    shortTermAssetsFormatted2DP: health.shortTermAssetsFormatted2DP,
    shortTermLiabilities: health.shortTermLiabilities,
    shortTermLiabilitiesFormatted0DP: health.shortTermLiabilitiesFormatted0DP,
    shortTermLiabilitiesFormatted2PD: health.shortTermLiabilitiesFormatted2PD,
    /**
     * Debt To Equity History
     */
    debt: health.debt,
    equity: health.equity,
    cash: health.cash,
    debtMax: health.debtMax,
    equityMax: health.equityMax,
    cashMax: health.cashMax,
    debtMin: health.debtMin,
    equityMin: health.equityMin,
    cashMin: health.cashMin,
    /**
     * Balance Sheet
     */
    liabilitiesBalanceSheet: health.liabilitiesBalanceSheet,
    assetsBalanceSheet: health.assetsBalanceSheet,
  };
};

export default connect<StateProps, unknown, ContainerProps>(mapStateToProps)(
  Health
);
